export function schema_library(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_result: {
				type: "string",
				title: "Colonne des résultats",
				default: "",
			},
			jsonpath: {
				type: "string",
				title: "jsonpath",
				default: "",
			},
			column_name: {
				type: "string",
				title: "Colonne des noms",
				default: "",
			},
			name: {
				type: "string",
				title: "Nom",
				default: "",
			},
			column_type: {
				type: "string",
				title: "Colonne des types",
				default: "",
			},
			type: {
				type: "string",
				title: "Type",
				default: "",
			},
			column_version: {
				type: "string",
				title: "Colonne des versions",
				default: "",
			},
			version: {
				type: "string",
				title: "Version",
				default: "",
			},
		},
	};
}
